<template>
  <button class="third-party-login" v-loading="loading" @click="handleLogin">
    <img class="icon" src="@/assets/icon-apple.svg" v-svg-inline />
    {{ $t('Continue with Apple') }}
  </button>
</template>

<script setup>
import { appleLogin, getTokenByAppAuthCode } from '@/api/user/user'
import gtagTools from '@/libs/gtag-tools'
import { closeNewWindow, getCookie, openNewWindow } from '@/libs/tools'
import { getSessionStorage, isInMacWebview, isInWebview } from '@/libs/utils'
import { loginSuccess, redirectUrl } from '@/services/login'
import { appStore } from '@/stores'
import { ref } from 'vue'

const loading = ref(false)
let btnClickTime = 0 // 轮询时间5分钟内
let checkStateTimeout = null

const newWindowName = 'thirdPartyLoginWindow'

const handleLogin = async () => {
  if (loading.value) return
  gtagTools.clickApple()
  loading.value = true
  // 非内嵌页下先打开一个窗口，防止ajax后再打开的话火狐浏览器会阻止新窗口的打开
  if (!isInWebview()) {
    openNewWindow('', newWindowName)
  }
  const params = {
    state: 'updfstate',
  }
  // 非mac端的内嵌页的需要轮询检测支付状态
  if (isInWebview() && !isInMacWebview()) params.needAppAuthCode = true
  const { data } = await appleLogin(params).catch(() => {
    loading.value = false
    closeNewWindow()
  })
  if (data.url) {
    let url = data.url
    if (isInWebview() && !isInMacWebview()) {
      const lang = appStore.language
      const deviceType = appStore.deviceType
      const schemeName = appStore.schemeName
      const gaUserId = getCookie('_ga')
      url = location.origin + `/index/redirect/${lang}/?schemeName=${schemeName}&deviceType=${deviceType}&gaUserId=${gaUserId}&url=` + encodeURIComponent(data.url)
    }
    // 如果有code需要轮询检测登录态
    if (data.appAuthCode) {
      btnClickTime = new Date().getTime()
      if (checkStateTimeout) {
        clearTimeout(checkStateTimeout)
        checkStateTimeout = null
      }
      handleCheckLoginState(data.appAuthCode)
    }
    redirectUrl('appleLogin', url, newWindowName)
  }
  setTimeout(() => {
    loading.value = false
  }, 2000)
  return false
}

// 轮询检测登录状态，并跳转到成功页
const handleCheckLoginState = appAuthCode => {
  getTokenByAppAuthCode(appAuthCode)
    .then(res => {
      loading.value = false
      loginSuccess('apple', res.data)
    })
    .catch(() => {
      // 轮询只在五分钟内
      if (new Date().getTime() - btnClickTime > 300 * 1000) return
      checkStateTimeout = setTimeout(() => {
        handleCheckLoginState(appAuthCode)
      }, 2000)
    })
}

// 网页端谷歌登录监听子窗口发来的回调事件
window.addEventListener('message', async e => {
  const data = e.data
  if (data.action === 'appleLoginSuccess') {
    const loginResult = data.params.loginResult
    loginSuccess('apple', loginResult)
    if (!getSessionStorage('disabledAutoCloseNewWindow')) closeNewWindow()
  }
})
</script>

<style scoped lang="scss">
.icon {
  :deep(path) {
    fill: var(--BG-10, #17291C);
  }
}
</style>
